// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2w7fS","subheader":"ReorderModal_subheader__3CUAy","listWrap":"ReorderModal_listWrap__eBWbH"};